import merge from 'lodash.merge';
import { SupportedLanguageCodes } from './SupportedLanguageCodes';
import { I18nEnvironmentConfig } from './EnvTypes';

// Default values
const defaults: I18nEnvironmentConfig = {
    DEFAULT_LANGUAGE: SupportedLanguageCodes.English,
    AVAILABLE_LANGUAGES: Object.values(SupportedLanguageCodes) as string[],
    PRELOAD_NAMESPACES: ['common', 'core', 'buttons', 'forms'],
    DEFAULT_NAMESPACE: 'common',

    DIRECT_TRANSLATION_API: {
        HOST: 'https://translate-qa.idplans.com',
        ENDPOINT: '/api/v1/Translate/Direct/{Key}/{Language}',
    },

    BUILT_TRANSLATION_FILES: {
        PATH: '/locales/{{lng}}/{{ns}}.json',
        REQUEST_OPTIONS: {
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
            },
        },
    },

    CACHES: {
        VERSION: APP_VERSION,
        STATIC: {
            PREFIX: 'i18next_res_',
            EXPIRATION_TIME: 7 * 24 * 60 * 60 * 1000, // 7 days
        },
        DYNAMIC: {
            PREFIX: 'idt_i18n_dt_',
            EXPIRATION_TIME: 7 * 24 * 60 * 60 * 1000, // 7 days
            MAX_MEMORY_ITEMS: 100,
            MAX_LOCAL_STORAGE_ITEMS: 1000,
        },
    },

    DETECTION: {
        ORDER: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
        LOOKUP_QUERYSTRING: 'lng',
        LOOKUP_COOKIE: 'i18next',
        LOOKUP_LOCAL_STORAGE: 'i18nextLng',
        CACHES: ['localStorage', 'cookie'],
        COOKIE_OPTIONS: {
            expires: new Date(Date.now() + 2 * 365 * 24 * 60 * 60 * 1000), // 2 years
        },
    },

    LOGGING: {
        STATIC_TRANSLATION: {
            ENABLED: false,
        },

        DYNAMIC_TRANSLATION: {
            ENABLED: false,
        },
    },

    TAG_PROCESSOR: {
        ENABLED: true,
        CONTENT_PRESERVING_TAGS: ['escape'],
        CONTENT_REMOVING_TAGS: ['translation-context'],
        ENABLE_LOGGING: false,
    },
};

// Environment-specific overrides
const envConfig = {
    local: {
        LOGGING: {
            STATIC_TRANSLATION: {
                ENABLED: true,
            },

            DYNAMIC_TRANSLATION: {
                ENABLED: true,
            },
        },

        TAG_PROCESSOR: {
            ENABLE_LOGGING: true,
        },

        CACHES: {
            STATIC: {
                EXPIRATION_TIME: 0,
            },
        },
    },
    qa: {
        CACHES: {
            STATIC: {
                EXPIRATION_TIME: 300000, // 5 minutes
            },
        },
    },
    prod: {
        DIRECT_TRANSLATION_API: {
            HOST: 'https://translate.idplans.com',
        },
    },
};

// Merge defaults with environment-specific config
const config = merge(defaults, envConfig[APP_ENVIRONMENT] || {}) as I18nEnvironmentConfig;

export default config;
